import { render, staticRenderFns } from "./SugerenciaCurso.vue?vue&type=template&id=4db95123&scoped=true"
import script from "./SugerenciaCurso.vue?vue&type=script&lang=js"
export * from "./SugerenciaCurso.vue?vue&type=script&lang=js"
import style0 from "./SugerenciaCurso.vue?vue&type=style&index=0&id=4db95123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db95123",
  null
  
)

export default component.exports